import './styles/App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from 'react';
import Toast from './components/toast';
import Home from './components/home';
import Nav from './components/nav';
import LoginPage from './components/authentication/loginPage';
import RegistrationForm from './components/authentication/registration';
import ForgotPassword from './components/authentication/forgotPassword';
import ResetPassword from './components/authentication/resetPassword';
import NotFound from './components/notFound';
import EmployeeDashboard from './components/employee/employeeDashboard';
import AdminDashboard from './components/admin/adminDashboard';
import HospitalDashboard from './components/hospital/hospitalDashboard';
import AdminHospitals from './components/admin/adminHospitals';
import EmployeeRegister from './components/employee/employeeRegister';
import HolderRegister from './components/employee/holderRegister';
import Services from './components/public/services';
import Hospital from './components/public/hospital';
import Locations from './components/public/locations';
import AdminEmployee from './components/admin/adminEmployee';
import HospitalQr from './components/hospital/hospitalQr';
import AdminHospital from './components/admin/adminHospital';
import EmployeeEdit from './components/employee/employeeEdit';
import HospitalEdit from './components/hospital/hospitalEdit';
import HolderEdit from './components/holder/holderEdit';
import AdminEmployeeCard from './components/admin/adminEmployeeCard';
import AdminPayouts from './components/admin/adminPayouts';
import EmployeeHolderCard from './components/employee/employeeHolderCard';
import AdminUnpaidHolders from './components/admin/adminUnpaidHolders';
import EmployeeSubordinate from './components/employee/employeeSubordinate';
import IncentivePanel from './components/employee/IncentivePanel';
import EmployeePayouts from './components/employee/employeePayouts';
import AdminEmployeeEdit from './components/admin/adminEmployeeEdit';

function App() {
  const { hash } = useLocation();
  const [role, setRole] = useState("");
  const [user, setUser] = useState("");
  const accessToken = sessionStorage.getItem('accessToken');

  useEffect(() => {
    if (!hash) return;

    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 160);
  }, [hash]);

  useEffect(() => {
    if (accessToken) {
      const decoded = jwtDecode(accessToken);

      const exp = decoded?.exp;
      if (Date.now() <= exp * 1000) {

        // @ts-ignore
        setRole(decoded?.userInfo.role || "");
        // @ts-ignore
        setUser(decoded?.userInfo.name || "");
      }
    } else {
      setRole('');
    }
  }, [accessToken]);

  return (
    <div className="App">
      <Toast />
      <Routes>
        <Route path="/" element={<Nav role={role} />}>
          {/* <Route path="id" element={<IDCard />}></Route> */}

          {/* public routes */}
          <Route index={role === "" ? true : false} element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="locations" element={<Locations />} />
          <Route path="hospital/:id" element={<Hospital />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<RegistrationForm />} />
          <Route path="forgot" element={<ForgotPassword />} />
          <Route path="reset" element={<ResetPassword />} />

          {/* private routes */}

          {role === "hospital" && (
            <>
              <Route
                index={role === "hospital" ? true : false}
                element={<HospitalDashboard user={user} />}
              />
              <Route path="edit" element={<HospitalEdit />} />
              <Route path="hospitalQr" element={<HospitalQr />} />
            </>
          )}

          {['village_cluster', 'mandal_officer', 'district_officer', 'area_manager'].includes(role) && (
            <>
              <Route
                index={['village_cluster', 'mandal_officer', 'district_officer', 'area_manager'].includes(role) ? true : false}
                element={<EmployeeDashboard user={user} role={role} />}
              />
              <Route path="register" element={<EmployeeRegister role={role} />} />
              <Route path="edit" element={<EmployeeEdit />} />
              <Route path="registerHolder" element={<HolderRegister />} />
              <Route path="holderCard/:id" element={<EmployeeHolderCard />} />
              <Route path="holderEdit/:id" element={<HolderEdit />} />
              <Route path="employee/:id" element={<EmployeeSubordinate />} />
              <Route path="employeeCard/:id" element={<AdminEmployeeCard />} />
              <Route path="incentives" element={<IncentivePanel role={role} />} />
              <Route path="payouts" element={<EmployeePayouts role={role} />} />
            </>
          )}

          {role === "admin" && (
            <>
              <Route
                index={role === "admin" ? true : false}
                element={<AdminDashboard user={user} />}
              />
              <Route path="unapproved" element={<AdminHospitals />} />
              <Route path="unpaid" element={<AdminUnpaidHolders />} />
              <Route path="hospitalPatients/:id" element={<AdminHospital />} />
              <Route path="registerEmployee" element={<EmployeeRegister role={role} />} />
              <Route path="employee/:id" element={<AdminEmployee />} />
              <Route path="employeeEdit/:id" element={<AdminEmployeeEdit />} />
              <Route path="employeeCard/:id" element={<AdminEmployeeCard />} />
              <Route path="holderCard/:id" element={<EmployeeHolderCard />} />
              <Route path="holderEdit/:id" element={<HolderEdit />} />
              <Route path="payouts" element={<AdminPayouts />} />
            </>
          )}

          {/* catch all */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
